module.exports = __webpack_public_path__ + "files/fb539281fc520210abe252e114616585.svg";